// #35838 — a new trailer's garage location defaults from the first vehicle's garage address,
// falling back to the first existing trailer's (the previous behavior) when the policy has no cars
// — so the FIRST trailer added gets a sensible default instead of none.
export const getDefaultGarageLocation = ({ cars, trailers } = {}) =>
  (Array.isArray(cars) && cars[0]?.garageLocation) ||
  (Array.isArray(trailers) && trailers[0]?.garageLocation) ||
  undefined;
